export * from './AuthService';
export * from './DepartmentsService';
export * from './TaskClosingCodesService';
export * from './TaskStatusesService';
export * from './TasksService';
export * from './EmployeesService';
export * from './AbsenceService';
export * from './FieldFillingTemplateService';
export * from './JobsAndScoresService';
export * from './AssetParametersService';
export * from './ObjectsService';
export * from './ProcessingWorkOrdersService';
export * from './TaskTypesService';
export * from './ActualJobsService';
export * from './RolesService';
export * from './CalendarService';
export * from './ScheduleService';
export * from './calendarAssignmentsServices/ScheduleDepartmentService';
export * from './calendarAssignmentsServices/SchedulePersonShiftService';
export * from './PersonAssignmentHistoryService';
export * from './AttainmentService';
export * from './LicenseService';